import at from './actionTypes'
import mt from './mutationTypes'

const actions = {
  [at.setLanguage](context, language) {
    if (context.state.language !== language) {
      context.commit(mt.setLanguage, language)
      context.state.languageCallback(language)
    }
  }
}

export default actions
